module.exports = __webpack_public_path__ + "images/rich_heading/other/coin/icon_eee17103345b6d1c0193899ed9f4a531.png";